import { Button, Text } from "@mantine/core";
import { GoogleLogo } from "@components/Logos/GoogleLogo.tsx";
import { GoogleUnlinkForm } from "./GoogleUnlinkForm";
import type { Password } from "../../../types/password";

interface GoogleAuthViewProps {
  showUnlinkForm: boolean;
  setShowUnlinkForm: (show: boolean) => void;
  password: Password;
  setPassword: React.Dispatch<React.SetStateAction<Password>>;
  onSuccess: () => void;
  onError: (error: string) => void;
  setNotification: (notification: {
    title: string;
    message: React.ReactNode;
    color: string;
  }) => void;
  setError: (error: { newPassword: string; confirmPassword: string }) => void;
  error: { newPassword: string; confirmPassword: string };
}

/**
 * View component for users authenticated via Google.
 * Shows instructions and provides option to unlink Google account.
 */
export const GoogleAuthView = ({
  showUnlinkForm,
  setShowUnlinkForm,
  password,
  setPassword,
  onSuccess,
  onError,
  setNotification,
  setError,
  error,
}: GoogleAuthViewProps) => {
  return (
    <div className="change-password">
      <div className="change-password-title">
        <h3>Change Password</h3>
        <Text c="dimmed">
          You are signed in with Google. To change your password, you can
          either:
        </Text>
        <Text c="dimmed" mt="sm">
          1. Update it through your Google account settings, or
        </Text>
        <Text c="dimmed" mt="xs">
          2. Unlink your Google account and set a password for this account.
        </Text>
      </div>

      {!showUnlinkForm ? (
        <Button
          onClick={() => setShowUnlinkForm(true)}
          color="red"
          variant="outline"
          c="black"
          radius="md"
          mt="md"
          leftSection={<GoogleLogo width={18} height={18} />}
        >
          Unlink Google Account
        </Button>
      ) : (
        <GoogleUnlinkForm
          password={password}
          setPassword={setPassword}
          onSuccess={() => {
            setShowUnlinkForm(false);
            onSuccess();
          }}
          onError={onError}
          onCancel={() => setShowUnlinkForm(false)}
          setNotification={setNotification}
          setError={setError}
          error={error}
        />
      )}
    </div>
  );
};
